
export interface HitlField {
  name: string;
  label: string;
  type: 'text' | 'textarea' | 'select';
  required: boolean;
  defaultValue?: string;
  maxLength?: number;
  options?: string[];
}

/** UI 입력 필드로 변환 */
export function parseHitlFields(rawValue: unknown): HitlField[] {
  if (!Array.isArray(rawValue)) return [];
  const fields: HitlField[] = [];

  for (const item of rawValue as Array<Record<string, unknown>>) {
    const textInput = (item['text-input'] ?? item.text_input) as Record<string, unknown> | undefined;
    const select = item.select as Record<string, unknown> | undefined;
    const paragraph = item.paragraph as Record<string, unknown> | undefined;
    const base = textInput ?? select ?? paragraph;
    if (!base) continue;

    fields.push({
      name: (base.variable as string) ?? '',
      label: (base.label as string) ?? '',
      type: textInput ? 'text' : select ? 'select' : 'textarea',
      required: Boolean(base.required),
      defaultValue: base.default_var as string | undefined,
      maxLength: textInput?.max_length as number | undefined,
      options: select?.options as string[] | undefined,
    });
  }
  return fields;
}
